import { render } from "./AbtestDemograSetPage.vue?vue&type=template&id=d2edf07c"
import script from "./AbtestDemograSetPage.vue?vue&type=script&lang=js"
export * from "./AbtestDemograSetPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__